import { colors } from 'theme'

export const defaultThemeStyles = {
    separator: colors.cloud,
    iconBackground: colors.white,
    customThemeBorder: colors.grey,
}
